module.exports = __webpack_public_path__ + "img/lightmode_pigmentation.2eab4872.png";